<template>
    <span v-if="sortValue === sortBy">
        <i class="fa fa-caret-up" v-if="sortDir === 'ASC'"></i>
        <i class="fa fa-caret-down" v-if="sortDir === 'DESC'"></i>
    </span>
</template>

<script>
    export default {
        props: {
            sortBy: {
                required: true,
            },
            sortDir: {
                required: true,
            },
            sortValue: {
                required: true,
            },
        },
        data(){
            return {};
        },
    }
</script>